// Multivariate Dependencies
import React from 'react';
// Components
import { InputBase } from '../../../common/components/InputBase/styles/InputBase';
import { InputContainer } from '../../../common/components/InputContainer';
import { InputState } from '../../../types';
export var PasswordInput = function (_a) {
    var placeholderText = _a.placeholderText, value = _a.value, _b = _a.state, state = _b === void 0 ? InputState.DEFAULT : _b, errorMessage = _a.errorMessage, title = _a.title, onChange = _a.onChange, onEnter = _a.onEnter;
    var callOnEnterIfEnterPressed = function (event) {
        if (event.key === 'Enter') {
            onEnter();
        }
    };
    return (React.createElement(InputContainer, { errorMessage: errorMessage, state: state, title: title },
        React.createElement(InputBase, { disabled: state === InputState.DISABLED || state === InputState.LOCKED, placeholder: placeholderText, value: value, onChange: onChange, onKeyDown: callOnEnterIfEnterPressed, type: 'password' })));
};
//# sourceMappingURL=PasswordInput.js.map